/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchAllNotificationDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'notifications',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.object([
            ['id', codecNumber],
            ['read', codecBoolean],
        ])),
    ],
]);
export class PatchAllNotificationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchAllNotificationDataParser.decode(input).map(res => new PatchAllNotificationData(res));
    }
    static unsafeDecode(input) {
        return PatchAllNotificationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchAllNotificationDataParser.encode(data);
    }
    static schema() {
        return PatchAllNotificationDataParser.schema();
    }
}
